const my_profile = {
  viewMyClubSeacretProfile: "ดูโปรไฟล์ ClubSeacret ของฉัน", // translated
  viewMoreDetails: "ดูรายละเอียดเพิ่มเติม", // translated
  verifiedEmail: "อีเมลที่ยืนยันแล้ว", // translated
  unverifiedEmail: "อีเมลที่ไม่ได้รับการยืนยัน", // translated
  pointsIn: "ชี้เข้า", // translated
  pointsOut: "ชี้ให้เห็น", // translated
  balance: "สมดุล", // translated
  pointsHistoryTable: "ตารางประวัติคะแนน", // translated
  topUp: "เติม", // translated
  createdFrom: "สร้างจาก", // translated
  createdTo: "สร้างถึง", // translated
  selectStatus: "เลือกสถานะ...", // translated
  searchByTitle: "ค้นหาตามชื่อเรื่อง...", // translated
  pushNotifications: "การแจ้งเตือนแบบ Push",
  pushNotificationsDescription: "รับการแจ้งเตือนจากเบราว์เซอร์สำหรับการอัปเดตและเหตุการณ์สำคัญ",
  pushNotificationsNotSupported: "การแจ้งเตือนแบบ Push ไม่ได้รับการสนับสนุนในเบราว์เซอร์นี้",
  pushNotificationsDeniedMessage: "การอนุญาตการแจ้งเตือนถูกปฏิเสธ กรุณาเปิดใช้งานการแจ้งเตือนในการตั้งค่าเบราว์เซอร์เพื่อรับการแจ้งเตือนแบบ Push",
  pushNotificationsEnabled: "เปิดใช้งานการแจ้งเตือนแบบ Push สำเร็จ",
  pushNotificationsDisabled: "ปิดใช้งานการแจ้งเตือนแบบ Push สำเร็จ",
  userInformationMissing: "ข้อมูลผู้ใช้หายไป",
  failedToUpdatePushNotifications: "ไม่สามารถอัปเดตการตั้งค่าการแจ้งเตือนแบบ Push",
  notificationPermissionDenied: "การอนุญาตการแจ้งเตือนถูกปฏิเสธ กรุณาเปิดใช้งานในการตั้งค่าเบราว์เซอร์",
  notificationPermissionRequired: "ต้องมีการอนุญาตการแจ้งเตือนเพื่อเปิดใช้งานการแจ้งเตือนแบบ Push",
  notSupported: "ไม่ได้รับการสนับสนุน",
  permissionDenied: "การอนุญาตถูกปฏิเสธ",
  permissionNotRequested: "ไม่ได้ขอการอนุญาต",
  enabled: "เปิดใช้งาน",
  disabled: "ปิดใช้งาน",
};

export default my_profile;
